<template>
  <div id="wt-home" :class="welcome?'welcome':''">
    <div class="loading" v-if="loading">
      <div class="title">Welcome to BPM</div>
    </div>
    <div class="wrapper">
      <div class="bpm-subtitle">Home</div>
      <div class="bpm-title">Pending Process</div>

      <b-tabs content-class="bpm-board-canvas" v-model="tabIndex" v-if="!createNew">
        <b-button id="bpm-new-btn" variant="primary" @click="createNew=!createNew">
          <i class="fa fa-plus new-icon"></i>
          <strong>Open New Task</strong>
        </b-button>

        <!-- TAB 1 -->
        <b-tab active id="tab-0">
          <template slot="title">
            Pendings
            <span
              v-if="(listUrgent.length+listNormal.length+listNewer.length) > 0"
              class="badge badge-pill badge-primary"
            >{{(listUrgent.length+listNormal.length+listNewer.length)}}</span>
          </template>

          <p
            class="mt-3"
            v-if="(listUrgent.length+listNormal.length+listNewer.length) == 0"
          >Nothing to Show</p>

          <div class="bpm-card-area" id="dragstartzone" @mousedown="startDrag" @mousemove="doDrag">
            <!-- CARD LIST -->
            <template v-if="listUrgent.length > 0">
              <BpmHomeCardList
                @selectedBpmTaskCard="columns = $event"
                @selectedBpmTaskList="tasklist = $event"
                :cardList="listUrgent"
                cardType="urgent"
                cardTitle="Urgent"
              ></BpmHomeCardList>
            </template>
            <template v-if="listNormal.length > 0">
              <BpmHomeCardList
                @selectedBpmTaskCard="columns = $event"
                @selectedBpmTaskList="tasklist = $event"
                :cardList="listNormal"
                cardType="normal"
                cardTitle="Normal"
              ></BpmHomeCardList>
            </template>
            <template v-if="listNewer.length > 0">
              <BpmHomeCardList
                @selectedBpmTaskCard="columns = $event"
                @selectedBpmTaskList="tasklist = $event"
                :cardList="listNewer"
                cardType="new"
                cardTitle="Newest"
              ></BpmHomeCardList>
            </template>
            <!-- CARD LIST FINISH -->
          </div>
        </b-tab>
        <!-- TAB 1 FINISH -->

        <!-- TAB 2 -->
        <b-tab id="tab-1">
          <template slot="title">
            Your Processes
            <span
              v-if="(yourListUrgent.length+yourListNormal.length+yourListNewer.length) > 0"
              class="badge badge-pill badge-primary"
            >{{(yourListUrgent.length+yourListNormal.length+yourListNewer.length)}}</span>
          </template>

          <p
            class="mt-3"
            v-if="(yourListUrgent.length+yourListNormal.length+yourListNewer.length) == 0"
          >Nothing to Show</p>

          <div class="bpm-card-area" id="dragstartzone" @mousedown="startDrag" @mousemove="doDrag">
            <!-- CARD LIST -->
            <template v-if="yourListUrgent.length > 0">
              <BpmHomeCardList
                @selectedBpmTaskCard="columns = $event"
                @selectedBpmTaskList="tasklist = $event"
                :cardList="yourListUrgent"
                cardType="urgent"
                cardTitle="Urgent"
              ></BpmHomeCardList>
            </template>
            <template v-if="yourListNormal.length > 0">
              <BpmHomeCardList
                @selectedBpmTaskCard="columns = $event"
                @selectedBpmTaskList="tasklist = $event"
                :cardList="yourListNormal"
                cardType="normal"
                cardTitle="Normal"
              ></BpmHomeCardList>
            </template>
            <template v-if="yourListNewer.length > 0">
              <BpmHomeCardList
                @selectedBpmTaskCard="columns = $event"
                @selectedBpmTaskList="tasklist = $event"
                :cardList="yourListNewer"
                cardType="new"
                cardTitle="Newest"
              ></BpmHomeCardList>
            </template>
            <!-- CARD LIST FINISH -->
          </div>
        </b-tab>
        <!-- TAB 2 FINISH -->

        <!-- TAB 3 -->
        <b-tab :disabled="taskDisable" id="tab-2">
          <template slot="title">
            Task
            <span
              v-if="!taskDisable"
              class="tab-close-btn"
              style="font-size: 10px"
              @click="closeTask()"
            >
              <i class="fas fa-times"></i>
            </span>
          </template>
          <template>
            <BpmHomeTaskEdit
              :objItems="columns"
              :taskList="tasklist"
              @forceCardListUpdate="generateCards()"
            ></BpmHomeTaskEdit>
          </template>
        </b-tab>
      </b-tabs>

      <div class="bpm-board-canvas" id="bpm-create-new-task" v-if="createNew">
        <template>
          <BpmHomeNewTask :createNew="createNew" @forceCardListUpdate="generateCards()"></BpmHomeNewTask>
        </template>
      </div>

      <!-- Alert -->
      <alert v-model="showAlert" :message="message" :variant="variant"></alert>
    </div>
  </div>
</template>

<script>
/* COMPONENTS - PAGE */
import BpmHomeCardList from "./bpm_home/BpmHomeCardList";
import BpmHomeTaskEdit from "./bpm_home/BpmHomeTaskEdit";
import BpmHomeNewTask from "./bpm_home/BpmHomeNewTask";
import alert from "@/components/widgets/Alert.vue";
/* JSON SIMULATING*/
import json from "./bpm_card.json";

export default {
  name: "BpmHomeContainer",
  components: { BpmHomeCardList, BpmHomeTaskEdit, BpmHomeNewTask, alert },
  computed: {
    mq() {
      return this.$mq;
    },
    showAlert() {
      return this.$store.getters["alert/showAlert"];
    },
    message() {
      return this.$store.getters["alert/message"];
    },
    variant() {
      return this.$store.getters["alert/variant"];
    }
  },
  data: function() {
    return {
      /* Loading */
      welcome: true,
      loading: true,

      /* Card List Array */
      listNewer: [],
      listNormal: [],
      listUrgent: [],
      yourListNewer: [],
      yourListNormal: [],
      yourListUrgent: [],

      /* drag scroll */
      dragging: false,
      startPos: 0,
      startX: 0,
      x: null,

      /* Data */
      createNew: false,
      tabIndex: 0,
      lastTab: 0,
      taskDisable: true,
      json: json,
      columns: null,
      tasklist: null,

      /* Simulate Data */
      gerenateJson: true,
      simDataA: 6,
      simDataB: 0,
      simDataC: 10,
      simDateNewer: null,
      simDateNormal: null,
      simDateUrgent: null
    };
  },
  methods: {
    /**
     * MONTA TAMBÉM O OBJETO QUE SERÁ ENVIADO AO COMPONENTE
     */
    generateCards() {
      console.log("Generating Cards");
      this.closeTask();
      this.createNew = false;
      this.listNewer = [];
      this.listNormal = [];
      this.listUrgent = [];
      let listOfObjects = [];

      let bpm_runner = this.getBpmRunner();

      let var_test = 0;
      bpm_runner.forEach(element => {
        Object.values(element.bpm_process_runner_data.tasks).map(key => {
          if (
            element.bpm_process_runner_data.current_tasks == key.bpm_task_id
          ) {
            key.process_label = element.bpm_process_runner_data.process_label;
            key.bpm_process_id = element.bpm_process_runner_data.bpm_process_id;
            key.bpm_process_runner_id = element.bpm_process_runner_id;

            /* Data Format */
            const months = [
              "Jan",
              "Fev",
              "Mar",
              "Abr",
              "Mai",
              "Jun",
              "Jul",
              "Ago",
              "Set",
              "Out",
              "Nov",
              "Dez"
            ];
            let newDate = new Date(key.open_task_dt);

            key.data_string =
              newDate.getDate() + " " + months[newDate.getMonth()];

            let tasklist = element.bpm_process_runner_data.tasks;
            key = { key, tasklist };

            listOfObjects.push(key);

            /**
             * REGISTRO: DIVISAO REALIZADA PARA TESTE
             */
            if (var_test == 0) this.listNewer.push(key);
            if (var_test == 1) this.listNormal.push(key);
            if (var_test == 2) this.listUrgent.push(key);
            if (var_test > 2) this.listNewer.push(key);

            //if (var_test == 1) this.yourListNewer.push(key);
            //if (var_test == 2) this.yourListNormal.push(key);
            if (var_test == 0) this.yourListUrgent.push(key);
            var_test++;
          }
        });
      });
    },

    getBpmRunner() {
      if (this.gerenateJson) {
        return this.json;
      } else {
        return [];
      }
    },

    getDateDiff(i) {
      const oneDay = 24 * 60 * 60 * 1000;
      const date = new Date();
      const today = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate()
      );
      let compare = null;

      compare = new Date(this.simDateNewer);
      if (i == 1) compare = new Date(this.simDateNormal);
      if (i == 2) compare = new Date(this.simDateUrgent);

      let diffDays = Math.round(Math.abs((today - compare) / oneDay));
      return diffDays;
    },

    closeTask() {
      this.columns = null;
    },
    isEmpty(obj) {
      for (let x in obj) {
        return false;
      }
      return true;
    },

    /* DRAG SCROLL EVENTS */
    checkPropag(path) {
      let check = false;
      for (let i = 0; i < 6; i++) {
        const e = path[i];
        if (e.className == "bpm-list") check = true;
      }
      return check;
    },
    startDrag(event) {
      if (!this.checkPropag(event.path)) {
        this.dragging = true;
        this.x = event.clientX;
        this.startPos = document.getElementById("dragstartzone").scrollLeft;
        this.startX = event.clientX;
      }
    },
    stopDrag() {
      this.dragging = false;
      this.x = null;
    },
    doDrag(event) {
      if (this.dragging) {
        this.x = event.clientX;
        let diff = this.startX - event.clientX;

        document.getElementById("dragstartzone").scrollLeft =
          this.startPos + diff;
      }
    }
    /* (FIM) DRAG SCROLL EVENTS */
  },
  watch: {
    columns() {
      if (this.columns) {
        this.createNew = false;
        this.taskDisable = false;
        this.$nextTick(() => {
          this.tabIndex = 2;
        });
      } else {
        this.taskDisable = true;
        if (this.tabIndex == 2) {
          this.$nextTick(() => {
            this.tabIndex = 0;
          });
        }
      }
    },
    tabIndex() {
      document.getElementById(`tab-${this.lastTab}`).style.display = "none";
      this.lastTab = this.tabIndex;
    }
  },
  created() {
    if (this.mq === "sm" || this.mq === "xs") {
      this.$store.commit("setTypeLayout", 2);
    } else {
      this.$store.commit("setTypeLayout", 3);
    }
  },
  mounted() {
    window.addEventListener("mouseup", this.stopDrag);

    setTimeout(() => {
      this.welcome = false;
    }, 1500);
    setTimeout(() => {
      this.loading = false;
    }, 2000);
    this.generateCards();
  }
};
</script>